import { ComingSoon } from "@/apps/_shared/ComingSoon";

export function ResearchPage() {
  return (
    <ComingSoon
      title="Legal Research Support"
      description="AI-assisted legal research, citations, and precedent discovery."
    />
  );
}
